import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import isEmpty from 'lodash/isEmpty';
import { Selectors } from '@grandvisionhq/auth';
import { Context } from '@grandvisionhq/carts-v2';
import { toast, Loader } from '@grandvisionhq/common';
import { Util } from '@grandvisionhq/forms';
import { useLink } from '@grandvisionhq/frk-routing';
import { Alert } from '@grandvisionhq/iris-ui';
import { useSync } from '@grandvisionhq/lib-utils-w3c';
import { WithUserData } from '@grandvisionhq/my-account';
import { ExpressPaymentMethod, ApplePayButton, GooglePayButton } from '@grandvisionhq/payments';
import { useDispatch, useSelector, useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { init, initOrder, toggleAccountCreation } from '../../../actions.js';
import { useCheckoutSettings } from '../../../context/CheckoutSettings/context.js';
import { pushCheckoutEventToDataLayer, pushExpressCheckoutSubmitEventToDataLayer } from '../../../data-layer.js';
import '@grandvisionhq/utils';
import { selectShippingMethod, toggleExpressCheckout, markFieldsTouched, setMyAccountValidation, setServiceStoreValidation } from '../../../StepShipping/actions.js';
import { isExpressCheckoutValid } from '../../../StepShipping/selectors.js';
import '../../../mappers/errors-mapping.js';
import '../../../utils/get-customer-details-payload.js';
import '../../../models/cart/cart-state.js';
import { CheckoutStepErrorType } from '../../../models/checkout/checkout-step-error-type.js';
import '../../../models/checkout-settings.js';
import { ShippingMethod } from '../../../models/step-shipping/shipping-methods.js';
import '../../../models/shared.js';
import 'history';
import '../../../utils/has-cart-errors.js';
import { useSyncCartShippingMethodWithReduxAfterTabFocus } from '../../../hooks/carts/use-sync-cart-shipping-method-with-redux.js';
import { useExpressCheckoutLabels } from '../../../hooks/common/use-express-checkout-labels.js';
import { getCheckout, getServiceStore, shouldCreateAccount, isInitialized } from '../../../selectors.js';
import '@grandvisionhq/graphql';
import '@grandvisionhq/lib-utils-cart';
import '@grandvisionhq/svc-tealium/events';
import '../../../operations/mutations/set-customer-details.js';
import '../../../operations/mutations/set-service-store.js';
import '../../../operations/mutations/set-shipping-method.js';
import '../../../operations/mutations/set-shipping-state.js';
import '../../../operations/mutations/create-apple-pay-session.js';
import '../../../operations/mutations/recreate-ordered-checkout.js';
import '@grandvisionhq/fun-orders';
import '@grandvisionhq/analytics';
import '../../../operations/fragments/checkout-mutation-result.js';
import '../../../operations/fragments/cart-mutation-failures.js';
import '../../../operations/fragments/recreate-ordered-checkout-failure.js';
import '../../../operations/fragments/recreate-ordered-checkout-result.js';
import '../../../operations/fragments/paypal-payment.js';
import '../../../operations/fragments/saved-user-details.js';
import '../../../operations/queries/get-checkout-state.js';
import '../../../operations/queries/get-user-details.js';
import { LoaderModal } from '../../LoaderModal/LoaderModal.js';
import { Header } from '../../Header/Header.js';
import '../hooks/apple-pay/use-apple-pay.js';
import '../hooks/google-pay/use-google-pay.js';
import { useHandleExpressPayment } from '../hooks/use-handle-express-payment.js';
import { ExpressCheckoutUI } from './ExpressCheckoutUI.js';

const ExpressCheckoutContainer = ({ type , backButton , shippingMethodsAsides , selfUrl , status ,  })=>{
    var ref5, ref1, ref2, ref3, ref4;
    const dispatch = useDispatch();
    const checkoutState = useSelector(getCheckout);
    const { getTitle  } = useExpressCheckoutLabels();
    const { cart , error , called , loading  } = Context.useCart();
    const checkoutSettings = useCheckoutSettings();
    const selectedServiceStore = useSelector(getServiceStore);
    const isLoggedIn = useSelector(Selectors.isLoggedIn);
    const shouldCreateAccountBoolean = useSelector(shouldCreateAccount);
    const isExpressCheckoutValidBoolean = useSelector(isExpressCheckoutValid);
    const isNearestPickup = (cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key) === ShippingMethod.NearestPickup;
    const intl = useIntl();
    const isCheckoutEventFired = React.useRef(false);
    const { onClick: redirectToCartPage , href: cartLink  } = useLink({
        route: 'cart.overview'
    }, {
        replace: true
    }) || {};
    const expressCheckoutRouteIsSupported = type === ExpressPaymentMethod.APPLE_PAY || type === ExpressPaymentMethod.GOOGLE_PAY;
    const expressCheckoutLink = useLink({
        route: 'express-checkout',
        params: {
            type: expressCheckoutRouteIsSupported ? type : ExpressPaymentMethod.GOOGLE_PAY,
            returnPath: cartLink,
            cartId: cart === null || cart === void 0 ? void 0 : cart.id
        }
    });
    const [payCartWithExpressPaymentMethod, orderInProcess] = useHandleExpressPayment({
        type,
        selfUrl,
        returnPath: expressCheckoutRouteIsSupported ? expressCheckoutLink === null || expressCheckoutLink === void 0 ? void 0 : expressCheckoutLink.href : cartLink
    });
    const isServiceStoreEnabled = (ref5 = checkoutSettings.features) === null || ref5 === void 0 ? void 0 : ref5.isServiceStoreEnabled;
    const isServiceStoreRequired = Boolean(isServiceStoreEnabled && !((ref1 = checkoutSettings.serviceStore) === null || ref1 === void 0 ? void 0 : ref1.isOptional));
    const broadCastChannel = useSync('new-cart-created').getChannel();
    broadCastChannel.onmessage = ()=>{
        toast.failed('cart.errors.cartNotInActiveState');
        redirectToCartPage === null || redirectToCartPage === void 0 ? void 0 : redirectToCartPage();
    };
    useSyncCartShippingMethodWithReduxAfterTabFocus();
    const isCreateAccountRequired = Boolean(((ref2 = checkoutSettings.account) === null || ref2 === void 0 ? void 0 : ref2.implicitAccountCreation) || ((ref3 = checkoutSettings.account) === null || ref3 === void 0 ? void 0 : ref3.createAccountRequired));
    const isFailedCheckoutStep = status === CheckoutStepErrorType.Failed;
    React.useEffect(()=>{
        // should only run once or when the cart or cart line items change
        if (!loading && cart && !isCheckoutEventFired.current) {
            const checkoutMethod = type === ExpressPaymentMethod.APPLE_PAY ? 'express_checkout_applepay' : 'express_checkout_googlepay';
            pushCheckoutEventToDataLayer(cart, intl.currency, checkoutMethod);
            isCheckoutEventFired.current = true;
        }
    }, [
        cart,
        intl.currency,
        loading,
        type
    ]);
    const { onClick: redirectToHomePage  } = useLink({
        route: 'home'
    }, {
        replace: true
    }) || {};
    React.useEffect(()=>{
        if (!isInitialized({
            checkout: checkoutState
        })) {
            // Initialize checkout state
            dispatch(init());
            dispatch(initOrder());
        }
    }, [
        dispatch,
        checkoutState,
        checkoutSettings.routes,
        selfUrl
    ]);
    React.useEffect(()=>{
        !isCreateAccountRequired && dispatch(toggleAccountCreation({
            shouldCreateAccount: false
        }));
    // should only run once or when the isCreateAccountRequired change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isCreateAccountRequired
    ]);
    React.useEffect(()=>{
        // Shipping Method is not allowed to be prefilled and has to be overwritten with the default.
        // Otherwise the setShippingMethod is not triggered correctly.
        // TO DO: design a sturdy cart and MyAccount based prefill mechanism.
        dispatch(selectShippingMethod({
            shippingMethod: {
                method: ShippingMethod.Delivery,
                isValid: true,
                isTouched: true
            }
        }));
        dispatch(toggleExpressCheckout({
            enabled: true
        }));
        return ()=>{
            dispatch(toggleExpressCheckout({
                enabled: false
            }));
        };
    }, [
        dispatch
    ]);
    const isStepValid = React.useCallback(()=>{
        const serviceStoreIsValid = isServiceStoreRequired ? !isEmpty(selectedServiceStore) : true;
        return isExpressCheckoutValidBoolean && serviceStoreIsValid && (isLoggedIn || !isCreateAccountRequired || shouldCreateAccountBoolean);
    }, [
        isExpressCheckoutValidBoolean,
        isServiceStoreRequired,
        selectedServiceStore,
        isLoggedIn,
        isCreateAccountRequired,
        shouldCreateAccountBoolean, 
    ]);
    const handleExpressCheckoutSubmitEvent = React.useCallback(()=>{
        cart && pushExpressCheckoutSubmitEventToDataLayer({
            cart,
            paymentMethod: type,
            isLoggedIn
        });
    }, [
        cart,
        isLoggedIn,
        type
    ]);
    const onCheckoutClick = React.useCallback(()=>{
        if (isStepValid() && payCartWithExpressPaymentMethod) {
            payCartWithExpressPaymentMethod();
            handleExpressCheckoutSubmitEvent();
        } else {
            var ref;
            dispatch(markFieldsTouched());
            if (isCreateAccountRequired && !shouldCreateAccountBoolean) {
                dispatch(setMyAccountValidation());
            }
            if (isServiceStoreEnabled && !((ref = checkoutSettings.serviceStore) === null || ref === void 0 ? void 0 : ref.isOptional)) {
                dispatch(setServiceStoreValidation());
            }
            toast.failed('checkout.errors.form.general');
            Util.focusToTopErrorFieldOnScreen();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch,
        handleExpressCheckoutSubmitEvent,
        isCreateAccountRequired,
        isServiceStoreEnabled,
        isStepValid,
        shouldCreateAccountBoolean,
        redirectToCartPage,
        (ref4 = checkoutSettings.serviceStore) === null || ref4 === void 0 ? void 0 : ref4.isOptional, 
    ]);
    React.useEffect(()=>{
        var ref;
        // - a valid cart with products is needed to enter the express-checkout
        if (!(cart === null || cart === void 0 ? void 0 : (ref = cart.lineItems) === null || ref === void 0 ? void 0 : ref.length) && !loading && called) {
            console.error(`Need a valid cart in localstorage or a cart with products.`);
            redirectToHomePage === null || redirectToHomePage === void 0 ? void 0 : redirectToHomePage();
        }
    }, [
        cart,
        called,
        loading,
        redirectToHomePage
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "express-checkout-container"
    }, /*#__PURE__*/ React.createElement(LoaderModal, {
        isModalOpen: Boolean(orderInProcess),
        subheading: intl.getLabel('checkout.order.inprogress')
    }), /*#__PURE__*/ React.createElement(Header, {
        title: getTitle(type),
        backButton: backButton
    }), /*#__PURE__*/ React.createElement("section", {
        className: "express-checkout-container__inner"
    }, /*#__PURE__*/ React.createElement("main", {
        className: "express-checkout-container__main"
    }, isFailedCheckoutStep && /*#__PURE__*/ React.createElement(Alert, {
        className: "alert-m-default checkout-section__alert",
        variant: "warning",
        title: intl.getLabel('checkout.errors.general.title')
    }, intl.getLabel('checkout.errors.general.message')), (loading || error) && /*#__PURE__*/ React.createElement("section", {
        className: "express-checkout-container__loader"
    }, /*#__PURE__*/ React.createElement(Loader, null)), cart && /*#__PURE__*/ React.createElement(ExpressCheckoutUI, {
        shippingMethodsAsides: shippingMethodsAsides,
        isNearestPickup: isNearestPickup
    })), /*#__PURE__*/ React.createElement("footer", {
        className: "express-checkout-container__footer"
    }, cart && type === ExpressPaymentMethod.APPLE_PAY && !orderInProcess && /*#__PURE__*/ React.createElement(ApplePayButton, {
        type: "express-checkout",
        onClick: onCheckoutClick
    }), cart && type === ExpressPaymentMethod.GOOGLE_PAY && !orderInProcess && /*#__PURE__*/ React.createElement(GooglePayButton, {
        type: "express-checkout",
        onClick: onCheckoutClick
    }))));
};
const ExpressCheckoutContainerWithUserData = WithUserData(ExpressCheckoutContainer);
const ExpressCheckoutContainerWithMyAccount = (_param)=>{
    var props = swcHelpers.extends({}, _param);
    const { isMyAccountEnabled  } = useFeatureToggles();
    return /*#__PURE__*/ React.createElement(ExpressCheckoutContainerWithUserData, swcHelpers.extends({}, props, {
        isMyAccountEnabled: isMyAccountEnabled
    }));
};

export { ExpressCheckoutContainerWithMyAccount as default };
//# sourceMappingURL=ExpressCheckoutContainer.js.map
